module.exports = __webpack_public_path__ + "1793882494189/images/40px.1f07573.png";